import { createContext } from "react";
import {
  Seat,
  ChartData,
  PickUpData,
  DropOffData,
} from "src/containers/chart/types";
import { ChartFareBreakup, ChartStore } from "./types";

interface ChartContextType extends ChartStore {
  setChartData: (data: ChartData) => void;
  setSelectedSeats: (data: Seat[]) => void;
  setFareBreakup: (data: ChartFareBreakup) => void;
  setSelectedPickup: (data: PickUpData) => void;
  setSelectedDropoff: (data: DropOffData) => void;
  setLoading: (data: string) => void;
  clearChartContext: () => void;
}

export const ChartContext = createContext<ChartContextType>(
  {} as ChartContextType
);
